import { combineLatest, concat, forkJoin, merge, race, zip } from "rxjs";
import { map } from "rxjs/operators";

export const combinationExamples = {
  combineLatest: {
    label: "combineLatest([$0, $1])",
    inputs: [
      [
        { t: 0, c: 1 },
        { t: 20, c: 2 },
        { t: 65, c: 3 },
        { t: 75, c: 4 },
        { t: 92, c: 5 }
      ],
      [
        { t: 10, c: "A" },
        { t: 25, c: "B" },
        { t: 50, c: "C" },
        { t: 57, c: "D" }
      ]
    ],
    apply: function (inputs) {
      return combineLatest([inputs[0], inputs[1]]).pipe(
        map(([x, y]) => `[${x.content},${y.content}]`)
      );
    }
  },

  concat: {
    label: "concat",
    inputs: [
      [{ t: 0, c: 1 }, { t: 15, c: 1 }, { t: 50, c: 1 }, 57],
      [{ t: 0, c: 2 }, { t: 8, c: 2 }, 12]
    ],
    apply: function (inputs) {
      return concat(...inputs);
    }
  },

  forkJoin: {
    label: "forkJoin",
    inputs: [
      [{ t: 0, c: "A" }, { t: 15, c: "B" }, { t: 30, c: "C" }, 50],
      [{ t: 37, c: "D" }, { t: 68, c: "E" }, 80]
    ],
    apply: function (inputs) {
      return forkJoin(inputs).pipe(
        map(([x, y]) => `[${x.content},${y.content}]`)
      );
    }
  },

  merge: {
    label: "merge",
    inputs: [
      [{ t: 0, c: 1 }, { t: 15, c: 1 }, { t: 50, c: 1 }, 57],
      [{ t: 0, c: 2 }, { t: 8, c: 2 }, 12]
    ],
    apply: function (inputs) {
      return merge(...inputs);
    }
  },

  race: {
    label: "race",
    inputs: [
      [
        { t: 10, c: 20 },
        { t: 20, c: 40 },
        { t: 30, c: 60 }
      ],
      [
        { t: 5, c: 1 },
        { t: 15, c: 2 },
        { t: 25, c: 3 }
      ],
      [
        { t: 20, c: 0 },
        { t: 32, c: 0 },
        { t: 44, c: 0 }
      ]
    ],
    apply: function (inputs) {
      return race(inputs);
    }
  },

  zip: {
    label: "zip",
    inputs: [
      [
        { t: 0, c: 1 },
        { t: 20, c: 2 },
        { t: 65, c: 3 },
        { t: 75, c: 4 },
        { t: 92, c: 5 }
      ],
      [
        { t: 10, c: "A" },
        { t: 25, c: "B" },
        { t: 50, c: "C" },
        { t: 57, c: "D" }
      ]
    ],
    apply: function (inputs) {
      return zip(inputs[0], inputs[1], (x, y) => "" + x.content + y.content);
    }
  }
};
